import React, { useState, useEffect } from 'react';
import api from '../services/axiosInstance';
import DataGridList from '../components/grid/DataGridList';

export default function UserManagement() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadData = async () => {
        setLoading(true);
        try {
            const usersRes = await api.get('/users');
            setUsers(usersRes.data);
        } catch (e) {
            console.error('Failed to load users data', e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadData(); }, []);

    const columns = [
        { dataField: "username", caption: "Username" },
        { dataField: "name", caption: "Name" },
        { dataField: "surname", caption: "Surname" },
        { dataField: "email", caption: "Email" },
        { dataField: "contact", caption: "Contact" },
        { dataField: "roleName", caption: "Role" },
        { dataField: "isActive", caption: "Active", dataType: "boolean" },
        { dataField: "useTelegram", caption: "Telegram Alerts", dataType: "boolean" },
        { dataField: "telegramId", caption: "Telegram ID" },
    ];

    return (
        <div className="portal-stack" style={{ maxWidth: "1200px" }}>
            <header className="dashboard-header">
                <div className="dashboard-title-area">
                    <h1>User Management</h1>
                    <p>Manage users, roles, and column preferences.</p>
                </div>
            </header>
            <section className="portal-panel">
                <DataGridList
                    data={users}
                    keyExpr="userId"
                    columns={columns}
                    showSearchPanel={true}
                    showPager={true}
                    pageSize={15}
                    isLoading={loading}
                    gridTitle="System Users"
                    showGridTitle={true}
                    refreshControl={
                        <button 
                            className="refresh-btn" 
                            onClick={loadData} 
                            disabled={loading}
                        >
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ animation: loading ? "spin 1s linear infinite" : "none" }}>
                                <polyline points="23 4 23 10 17 10" />
                                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
                            </svg>
                            {loading ? "Refreshing..." : "Refresh"}
                        </button>
                    }
                />
            </section>
        </div>
    );
}
